import config from "../../config";

export default class ConfigUtils
{
	/**
	 * used to return a formatted string of the product's version and build information
	 * the build information is injected into the environment variables by the CI/CD pipeline
	 * ideally a "major.minor.patch (build_number)" string is returned
	 * in case the build information is not available, display just the version number
	 *
	 * @static
	 * @return {*} 
	 * @memberof Utils
	 */
	static getProductVersionBuild(buildString?: string)
	{
		buildString ??= config.RELEASE_VERSION;
		if(buildString)
		{
			// the build format is something like this: commitHash.environment.buildNumber
			const buildNumber = buildString.split(".").pop();
			return `${config.CREATE_VERSION} (${buildNumber})`;
		}
		else
		{
			return config.CREATE_VERSION;
		}
	}
}